import i18n from "@/i18n";
import { format } from "date-fns";
import { ToastT, toast } from "sonner";

// #region getUserLanguage
export function getUserLanguage() {
  const lang = localStorage.getItem("i18nextLng") || "en";
  return lang;
}
// #endregion getUserLanguage

// #region setUserLanguage
export function setUserLanguage(iso_code: string) {
  localStorage.setItem("i18nextLng", iso_code);
}
// #endregion setUserLanguage

// #region systemErrorAlertText
export function systemErrorAlertText(): string {
  let htmlContent = "";
  htmlContent += `<div class="mt-5">${i18n.t("If you're encountering any issues, we're here to help!")}</div>`;
  // htmlContent += `<div class="mt-2">${i18n.t("Please don't hesitate to contact us directly at")} <a class="text-secondary" href="mailto:${getSupportEmail()}">${getSupportEmail()}</a>.</div>`;

  return htmlContent;
}
// #endregion systemErrorAlertText

// #region getSupportEmail
export function getSupportEmail(): string {
  return import.meta.env.VITE_PROJECT_SUPPORT_EMAIL || "";
}
// #endregion getSupportEmail

export function getAlertTypeString(alertType: string): string {
  // TODO: Change per client requirements
  switch (alertType) {
    default:
      return i18n.t("Unknown Alert Type");
  }
}

// #region formatDate
export function formatDatePretty(
  date: string | Date | null | undefined,
  includeTime: boolean = false,
  showTriggerSeconds: boolean = false
): string {
  if (!date) {
    return "";
  }

  const parsedDate = new Date(date);
  if (isNaN(parsedDate.getTime())) {
    return "";
  }

  const dateFormat = includeTime
    ? showTriggerSeconds
      ? "yyyy/MM/dd HH:mm:ss"
      : "yyyy/MM/dd HH:mm"
    : "yyyy/MM/dd";
  return format(parsedDate, dateFormat);
}
// #endregion formatDatePretty

export function getBuildDate(): Date | null {
  // get the build date from meta tag
  // <meta name="build-date" content="2025-01-15T06:20:16.027Z" />
  const el = document.querySelector('meta[name="build-date"]');
  if (!el) return null;
  const date = el.getAttribute("content");
  if (!date) return null;
  return new Date(date);
}

//VITE_INCLUDE_LANGUAGE_SUPPORT
export function isLanguageSupportEnabled(): boolean {
  const langBool = import.meta.env.VITE_INCLUDE_LANGUAGE_SUPPORT;
  if (langBool === "true") return true;
  return false;
}

// #region Toasts
// Error
export function genericFailureToast(
  message: string,
  position?:
    | "top-left"
    | "top-right"
    | "bottom-left"
    | "bottom-right"
    | "top-center"
    | "bottom-center",
  actionLabel?: string,
  callback?: () => void
): void {
  toast.error("Error", {
    description: message,
    duration: 3000,
    position: position ?? undefined,
    ...(callback && {
      action: {
        label: actionLabel ?? "",
        onClick: callback,
      },
    }),
  });
}

export type ToastOptions = {
  position?: ToastT["position"];
  actionLabel?: string;
  callback?: () => void;
};

// Success
export function genericSuccessToast(
  message: string,
  options?: ToastOptions
): void {
  toast.success("Success", {
    description: message,
    duration: 3000,
    position: options?.position ?? undefined,
    ...(options?.callback && {
      action: {
        label: options?.actionLabel ?? "",
        onClick: options?.callback,
      },
    }),
  });
}

// #endregion Toasts

// #region getMilliseconds
// Utility function to get the milliseconds from the days, hours, minutes, and seconds
export function getMilliseconds({
  d,
  h,
  m,
  s,
}: {
  d: number;
  h: number;
  m: number;
  s: number;
}): number {
  return (d * 24 * 60 * 60 + h * 60 * 60 + m * 60 + s) * 1000;
}
// #endregion getMilliseconds
